export default __webpack_public_path__ + "static/media/GAC_Beginner_FINAL_24_Apr.a990ed73.png";